import { useOnboardingStore } from '../../../store/onboardingStore';
import { dictionary } from '../../../utils/dictionary';
import { useAuth } from '../../../context/AuthContext';
import { ConfirmScrapedProductView } from '../ui/ConfirmScrapedProductView';

interface StepConfirmScrapedProductProps {
  onBack: () => void;
  onConfirm: () => void;
}

export function StepConfirmScrapedProduct({ onBack, onConfirm }: StepConfirmScrapedProductProps) {
  const { language } = useAuth();
  const { data, updateProductData, updateVisualContent } = useOnboardingStore();
  const { productData, visualContent } = data;
  const images = visualContent.images || [];

  return (
    <ConfirmScrapedProductView
      title={dictionary["confirm-product-details"]?.[language] ?? "Confirm your product details"}
      subtitle=""
      name={productData.name || ''}
      description={productData.details || ''}
      images={images}
      onNameChange={(value) => updateProductData({ ...productData, name: value })}
      onDescriptionChange={(value) => updateProductData({ ...productData, details: value })}
      onImagesUpdate={(newImages) => updateVisualContent({ images: newImages })}
      onBack={onBack}
      onConfirm={onConfirm}
    />
  );
}
